import { useTranslation } from 'react-i18next';
import { BudgetBys } from 'business/constants';
import React, { useContext } from 'react';
import { Tooltip } from '@mui/material';
import { isEqual } from 'lodash';
import { Locker } from './Locker';
import { isCustomBudgetProposal } from '../../BudgetProposal/Resource/hooks/budgetProposal';
import { getClientBind } from 'store/APIClient';
import { getResourceLabel } from 'routes/BudgetModule/components/shared/helpers/getResourceLabel';
import { IntegrationContext } from 'routes/BudgetModule/components/BudgetWithProvider/IntegrationContext';
import { isAmp } from 'routes/BudgetModule/helpers/bind';

type ResourceLockerProps = {
    resourceSoftwareId: string;
    by: BudgetBys;
    rights?: (string | null)[];
};

/**
 * This component is used to display a locker icon with a custom tooltip based on the resource.
 */
const ResourceLocker = ({
    resourceSoftwareId,
    by,
    rights = undefined,
}: ResourceLockerProps) => {
    const { t } = useTranslation();
    const integrations = useContext(IntegrationContext);
    const isSchool = isCustomBudgetProposal(integrations);
    const bind = getClientBind();

    if (rights === undefined) {
        return <></>;
    }

    // sometimes resourceSoftwareId can be empty string
    // this is a side effect of the get_data call that transforms null to empty string
    // we had to change the budget_proposal serializer in the back to translate
    // None to "" because of this
    const locked = !rights.includes(resourceSoftwareId);
    const article = isAmp(bind) ? 'cette' : 'ce';
    const resourceType = getResourceLabel(by, isSchool, bind);
    const title = t('budgetProposal.updateDisabled', {
        article,
        resourceType,
    });
    const tooltipText = locked ? title : t('budgetProposal.updateEnabled');

    return (
        <Tooltip title={tooltipText}>
            <div>
                <Locker locked={locked} />
            </div>
        </Tooltip>
    );
};

export default React.memo(ResourceLocker, isEqual);
